'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var CommentsController = function CommentsController($scope, commentsService, configurationService, $filter, $log) {
  $scope.uniqueId = $scope.level + '-comment-' + Math.random().toString().substr(2);
  $scope.formDisabled = false;
  $scope.commentData = {
    text: ''
  };

  //for grid header
  if ($scope.headerFormat) {
    var rmMomentFormat = $filter('rmMomentFormat');
    var headerFormat = _.chain($scope.headerFormat).replace(/date\((\w+)\)/, function (m, propName) {
      return rmMomentFormat($scope.entityData[propName], 'DATE_USER_SETTINGS');
    }).replace('${segmentClass} Segment Class', '').value();
    $scope.gridHeaderCaption = _.template(headerFormat)($scope.entityData);
  }
  function updateComments(comments) {
    $scope.comments = comments;
    if ($scope.onCommentsUpdated) {
      $scope.onCommentsUpdated({
        comments: comments
      });
    }
    if (comments) {
      $scope.$emit('comments:updated', $scope.comments.length);
    }
  }
  function showError(message) {
    $log.error('CommentsController - ' + message);
    toastr.error(message);
  }
  $scope.updateComments = function () {
    commentsService.get($scope.entityData, $scope.entityKey).then(updateComments, showError.bind(null, 'Error occurred during loading notes'));
  };
  $scope.updateComments();
  function disableForm() {
    $scope.formDisabled = true;
  }
  function enableForm() {
    $scope.formDisabled = false;
  }
  function cleanText() {
    $scope.commentData.text = '';
  }
  function addCommentToList(comment) {
    if ($scope.comments) {
      $scope.comments.unshift(comment);
    } else {
      $scope.comments = [comment];
    }
    $scope.$emit('comments:updated', $scope.comments.length);
  }
  $scope.save = function () {
    $scope.xtForm.submit();
    if (!$scope.xtForm.form.$invalid) {
      disableForm();
      commentsService.save($scope.entityData, $scope.entityKey, $scope.commentData.text, $scope.level).then(addCommentToList).then($scope.hideForm).then(cleanText)["catch"](showError.bind(null, 'Error occurred during saving'))["finally"](enableForm);
    }
  };
};
CommentsController.$inject = ['$scope', 'CommentsService', 'ConfigurationService', '$filter', '$log'];
module.exports = CommentsController;